import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { PersonInfo } from "./overview.service";

@Component({
    selector: "remark-dialog",
    template: require('./remark-dialog.component.html')
})
export class RemarkDialog implements OnInit {

    constructor(
        private fb: FormBuilder,
        private dialogRef: MatDialogRef<RemarkDialog>) { }

    remarkForm: FormGroup;

    inputRemark: string;
    inputPersonId: number;
    inputYear: number;
    inputMonth: number;
    inputDayOfMonth: number;

    personInfo: PersonInfo[] = [];
    daysOfMonth: number[] = [];

    isEdit: boolean;

    get personId() { return this.remarkForm.get('personId'); }

    get dayOfMonth() { return this.remarkForm.get('dayOfMonth'); }

    get remark() { return this.remarkForm.get('remark'); }

    ngOnInit(): void {
        this.remarkForm = this.fb.group({
            personId: [this.inputPersonId, Validators.required],
            dayOfMonth: [this.inputDayOfMonth, Validators.required],
            remark: [this.inputRemark, Validators.required]
        });

        const numberOfDays = new Date(this.inputYear, this.inputMonth + 1, 0).getDate();
        for (let i = 1; i <= numberOfDays; i++) {
            this.daysOfMonth.push(i);
        }

        this.isEdit = !!this.inputDayOfMonth;

        if (this.isEdit) {
            this.personId.disable();
            this.dayOfMonth.disable();
        }

        this.dialogRef.keydownEvents().subscribe(event => {
            if (event.key === "Escape") {
                this.dialogRef.close();
            }
        });
    }

    onSubmit(): void {
        this.dialogRef.close({ ...this.remarkForm.value, delete: false });
    }

    delete(): void {
        this.dialogRef.close({ delete: true });
    }

    getDayDisplayValue(d: number): string {
        return `${this.getNumberAsTwoDigitString(d)}-${this.getNumberAsTwoDigitString(this.inputMonth + 1)}-${this.inputYear}`;
    }

    private getNumberAsTwoDigitString(x: number): string {
        return `${x < 10 ? "0" : ""}${x}`;
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/activities/overview/remark-dialog.component.ts